import {useEffect, useState,Fragment} from "react";
import {useNavigate,useParams} from "react-router-dom";


import {useDispatch} from "react-redux";
import MainLayout from "../../../commons/layout/MainLayout/index";

import HeaderHs2 from "../../../commons/components/Header/headerHs2";
import ROUTERS from "../../../commons/constans/router";
import InfiniteScroll from 'react-infinite-scroll-component';
import _styles from "./_styles.scss"
import moment from "moment";
import ListItemComponent from "../../../commons/components/List/ListItemComponent";
import SkeletonLoadingComponent from "../../../commons/components/SkeletonLoading";


const QnaPageComponent = (props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [qnaList, setQnaList] = useState([])
    const [page, setPage] = useState(1)
    const [statusLoading, setStatusLoading] = useState(true)
    const [statusListEmpty, setStatusListEmpty] = useState(false)

    useEffect(() => {
        scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if(props.loadMore){
            setStatusLoading(true)
        }else {
            setStatusLoading(false)
        }
    }, [props]);

    useEffect(() => {
        let dataList = []
        if(qnaList.length > 0) {
            dataList= [...qnaList,...(props?.qnaData?.data || [])]
        }else {
            dataList=props?.qnaData?.data || [];
        }
        setQnaList(dataList)
    }, [props?.qnaData?.data]);

    useEffect(() => {

        if(qnaList.length > 0) {
            setStatusListEmpty(true)
        }else {
            setStatusListEmpty(false)
        }

    }, [qnaList]);

    const backMenuHome = () => {
        navigate(ROUTERS.HOME, {
            state: {
                menuStatus: true
            }
        })
    }

    const openDetail = (id) => {
        console.log(id, 'openDetail');
        let url = ROUTERS.QNA_DETAIL
        url = url.replace(':id',id)
        navigate(url)
    }
    const fetchMoreData = () => {
        let dataFetch = [...qnaList];
        if (props?.qnaData?.from < props?.qnaData?.last_page && statusLoading) {
            let pageLoad = page + 1;
            setPage(pageLoad)
            let params= '?page='+pageLoad
            props.fetchData(params)
        }
    }

    const loadingDiv = <div className="lists__item">
        <div className="lists__item__content w-100 loading-content">
            <p className="w-100">
                <SkeletonLoadingComponent circle={false} width="20%" height="14px"/>
            </p>
            <p className="w-100 pt-1 pb-1">
                <SkeletonLoadingComponent circle={false} width="100%" height="18px"/>
            </p>
            <p className="w-100">
                <SkeletonLoadingComponent circle={false} width="30%" height="14px"/>
            </p>
            </div>
            <div className="">
                {/*<SkeletonLoadingComponent circle={false} width="20px" height="14px"/>*/}
        </div>
    </div>



    return (
        <MainLayout pageID={"qna-list"} displayBottomNav={false} >
            <HeaderHs2
                title={"나의 문의내역"}
                labelLeft={true}
                handleLabelLeft={backMenuHome}
                labelRight={false}
            />
            <div className="wrapper">

                <section className="lists">
                    {props.loading ? ([...Array(10).keys()].map(e => (
                                    <Fragment key={e}>
                                        {loadingDiv}
                                    </Fragment>
                                ))) : ( qnaList.length > 0 ? <InfiniteScroll
                            dataLength={qnaList.length}
                            next={fetchMoreData}
                            hasMore={statusLoading}
                            loader={loadingDiv}
                        >
                            {qnaList.map((value,key)=>(

                                <Fragment key={key}>
                                    <ListItemComponent
                                        subTitle={moment(value.created_at).format('Y-MM-DD')}
                                        title={value.question_subject}
                                        description={value?.type_qna?.name}
                                        rightArrow={value.state == 'new' ? true : false}
                                        handleClick={()=>openDetail(value.id)}
                                        actionButtonHandle={()=>openDetail(value.id)}
                                        actionButton={value.state != 'new' ? true : false}
                                        actionButtonLabel={value.state != 'new' ? '답변완료' : ''}
                                    />
                                </Fragment>

                            ))}


                        </InfiniteScroll> :(<div className="lists__empty">
                            <img src="/images/img_notfound.svg" />
                            <p className="lists__empty__description">나의 문의 내역이 없습니다.</p>
                        </div>))}


                    {/*{statusListEmpty ? '' : (<div className="lists__empty">*/}
                    {/*    <img src="/images/img_notfound.svg" />*/}
                    {/*    <p className="lists__empty__description">나의 문의 내역이 없습니다.</p>*/}
                    {/*</div>)}*/}


                </section>

            </div>
        </MainLayout>
    );
};

export default QnaPageComponent;
